function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "transactions");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "transactions",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "payment2",
  fill: "#4D4D4D",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.7482026,2.55677703 C33.9533655,1.23838488 35.1204715,0.131012918 36.4559659,0.0245348446 C37.3772635,-0.0993669138 38.3082385,0.254914677 38.9759857,0.886039259 C46.9308871,7.82453773 54.891595,14.7533564 62.8387544,21.6976627 C63.7542455,22.4391373 64.2090878,23.7071944 63.9071499,24.8571576 C63.5955346,26.2375006 62.2426207,27.265498 60.8297063,27.2151629 C41.6102,27.2190349 22.3906938,27.2151629 3.17312298,27.2170989 C1.47956125,27.2887296 -0.0746445469,25.7631892 0.00277541799,24.0634119 C-0.00883757674,22.4081619 1.49504524,20.9561882 3.14796149,21.022011 C19.646156,21.0162031 36.142415,21.0258829 52.638674,21.018139 C46.6831432,15.822009 40.7237414,10.629751 34.7701461,5.43168502 C33.947559,4.74248149 33.5604592,3.60994198 33.7482026,2.55677703 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.0163239118,40.1261133 C-0.171419503,38.3721291 1.39246379,36.716879 3.15183249,36.7943176 C22.3848873,36.7904457 41.617942,36.7943176 60.8509968,36.7943176 C61.9619733,36.7614062 63.0439173,37.3867229 63.5858571,38.3547054 C64.2826367,39.5046686 64.0774738,41.1037757 63.1174663,42.0427187 C62.5329455,42.6622275 61.6871324,42.9990854 60.8413193,42.9855336 C44.3508668,42.9913415 27.8584788,42.9855336 11.3680263,42.9894055 C17.3274281,48.1855355 23.2926363,53.3758576 29.2423606,58.5816674 C30.4888221,59.6212806 30.659146,61.6656597 29.592686,62.8930614 C28.5475165,64.2056457 26.4049189,64.3876264 25.1700705,63.2415351 C17.3080731,56.3920911 9.45768863,49.5290952 1.5918202,42.685459 C0.782781564,42.0601423 0.0608403916,41.196702 0.0163239118,40.1261133 Z",
  id: "Path"
})));

var SvgTransactions = function SvgTransactions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransactions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transactions.881c3465.svg";
export { ForwardRef as ReactComponent };